/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTiposClientesVistaProps } from '../interfaces';
import { acciones, columnas } from './constantes';

const VistaTiposClientes: React.FunctionComponent<ITablaTiposClientesVistaProps & InjectedIntlProps> = ({
    tiposClientess,
    cargarTiposClientes,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tiposClientess}
            actions={acciones(manejarFormulario, cargarTiposClientes, intl.formatMessage, confirmarEliminacion)}
        />
    </div>
);

export default injectIntl(VistaTiposClientes);
